/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Form, Formik, Field } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import Layout from 'components/Layout';
import Colors from 'constants/Colors';
import { ButtonContent } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import StepNavigation from 'components/StepNavigation'
import {
  Table,
  DialogCalculation,
  NotesModal,
  Button,
  ButtonContainer,
  LostCancelButton,
  FormSectionGlobal as FormSection,
  HasPermission,
  MobileTable,
  Clauses
} from '@fitinsur/components'
import TableCalculationList from 'components/TableCalculationList'
import {
  AddButton,
  Content,
  TitleBar,
  TitleInfo,
  TitleAlter,
  Option,
  BrokerContainer,
  CoverageContainer,
  Plan,
  TextQuestion,
  ClausesContainer,
  ClauseContent,
  RefreshButon
} from './styles';
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import BrokingSummary from 'components/BrokingSummary';
import MasksHelper from 'utils/src/masks';
import Icon from 'components/Icon'
import * as yup from 'yup';
import { isNumber } from '@fitinsur/utils';
import { CheckBox } from "@fitinsur/components";
import { useGetDocuments, useGetDocuments as useGetDocumentsExpired } from 'services/DocumentsService';
import { useRecalculateSync, useComissionRate, useCalculateCancellationSync } from 'services/PremiumCalculationService';
import {
  LoaderContext
} from '@fitinsur/contexts'
import { useResetOperationState, useUpdateOperationSync } from 'services/OperationService';
import {
  useGetOperationAsync,
} from '@fitinsur/services/OperationService';
import { useVerifyRiskAcceptance } from 'services/RiskAcceptanceService';
import { useGetQuestionnaireAnswer, useSaveQuestionnaireAnswer, useSaveQuestionnaireAnswerSync } from 'services/QuestionnaireAnswerService';
import { useGenerateQuoteASync } from 'services/QuoteService';
import {
  useUpdateDocumentsClausesSync
} from 'services/ClausesService';
import {
  useRequestSompoGetInternalProcessNumber,
  useRequestSompoGetInstallments
} from 'services/IssueService';
import { onValidationError } from 'containers/edit/handleQuestionChange';
import { cloneDeep, isEmpty } from 'lodash';

export default function Plans({ permissions, ...props }) {
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const [notesModal, setNotesModal] = useState(false);
  const validationSchema = useRef(yup.object().shape({}));
  const loading = useContext(GlobalLoaderContext);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const authContext = useContext(GlobalAuthContext);
  const mc = new MessageCenter();
  const formikRef = useRef({});
  const recalculateParameters = useRef([])
  const [operation, setOperation] = useState({});
  const [isBound, setIsBound] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);
  const handleBack = () => history.goBack();
  const [isInAnalysis, setIsInAnalysis] = useState(null);
  const [clauseGroups, setClauseGroups] = useState([]);
  const [selectedClauses, setSelectedClauses] = useState([]);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [fullCoverageList, setFullCoverageList] = useState([]);
  const [productName, setProductName] = useState('');
  const [groupDeductible, setGroupDeductible] = useState([]);
  const [hasCoverageCalc, setHasCoverageCalc] = useState(false);
  const [idProductPlan, setIdProductPlan] = useState(0);
  const [minCommissionValue, setMinCommissionValue] = useState(0);
  const [maxComissionValue, setMaxCommissionValue] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [previousCoverageCalcList, setPreviousCoverageCalcList] = useState([]);
  const [clausesLoading, setClausesLoading] = useState(false);
  const [reloadClauses, setReloadClauses] = useState(null);
  const [overwriteQstValues, setOverwriteQstValues] = useState({});

  const HAS_APPROVAL_AND_REJECT_PERMISSION = useMemo(() => {
    return operation?.idDomain === 26 ? permissions.NBI_REQUEST_APPROVE_REJECT : permissions.ENDORSEMENT_APPROVE_REJECT;
  }, [operation?.idDomain, permissions.NBI_REQUEST_APPROVE_REJECT, permissions.ENDORSEMENT_APPROVE_REJECT]);

  const HAS_CANCEL_PERMISSION = useMemo(() => {
    return operation?.idDomain === 26 ? permissions.CANCEL_ENQUIRY : permissions.CANCEL_ENDORSEMENT;
  }, [operation?.idDomain, permissions.CANCEL_ENQUIRY, permissions.CANCEL_ENDORSEMENT]);

  const HAS_EXECUTE_PERMISSION = useMemo(() => {
    return operation?.idDomain === 26 ? permissions.ORDER_TO_BIND_GENERATE : permissions.EXECUTE_ENDORSEMENT;
  }, [operation?.idDomain, permissions.ORDER_TO_BIND_GENERATE, permissions.EXECUTE_ENDORSEMENT]);

  const goToNextPage = useRef(false);
  const questionMappingAdhocParameters = useRef([]);
  const changeEndorsmentPremium = useRef(false);
  const getQuestionnaire = useRef(false);

  const [coverageCalcList, setCoverageCalcList] = useState([{
    coverageCalc: [{
      coverageLimit: "0",
      coveragePremium: "0",
      coverageAmount: "0",
      coverageComissionRate: "0",
      coverageComission: "0",
      coverageTax: "0",
      coverageAmountTaxLess: "0",
      deductibleDescription: "",
      coverageItems: []
    }]
  }]);
  const finishedAnalysis = questionnaire.find(qst => qst.idQuestion === 3457)?.idAnswerOption === 8995;

  const {
    data: useGetDocumentsData,
    loading: useGetDocumentsLoading,
    error: useGetDocumentsError,
    status: useGetDocumentsStatus,
    request: useGetDocumentsRequest
  } = useGetDocuments(props.match.params.idOperation);

  const {
    data: useGenerateQuoteData,
    loading: useGenerateQuoteLoading,
    error: useGenerateQuoteError,
    status: useGenerateQuoteStatus,
    request: useGenerateQuoteRequest
  } = useGenerateQuoteASync(props?.match?.params?.idOperation);

  const {
    data: useGetDocumentsExpiredData,
    loading: useGetDocumentsExpiredLoading,
    error: useGetDocumentsExpiredError,
    status: useGetDocumentsExpiredStatus,
    request: useGetDocumentsExpiredRequest
  } = useGetDocuments(props.match.params.idOperation);

  const {
    data: useRecalculateSyncData,
    loading: useRecalculateSyncLoading,
    error: useRecalculateSyncError,
    status: useRecalculateSyncStatus,
    request: useRecalculateSyncRequest
  } = useRecalculateSync(props.match.params.idOperation);

  const {
    data: useComissionRateData,
    loading: useComissionRateLoading,
    error: useComissionRateError,
    status: useComissionRateStatus,
    request: useComissionRateRequest
  } = useComissionRate(props.match.params.idOperation);

  const {
    loading: useUpdateOperationLoading,
    request: useUpdateOperationRequest
  } = useUpdateOperationSync(props.match.params.idOperation);

  const {
    data: useResetOperationStateData,
    loading: useResetOperationStateLoading,
    error: useResetOperationStateError,
    status: useResetOperationStateStatus,
    request: useResetOperationStateRequest,
  } = useResetOperationState(props.match.params.idOperation);

  const {
    data: useGetOperationData,
    loading: useGetOperationLoading,
    error: useGetOperationError,
    status: useGetOperationStatus,
    request: useGetOperationRequest,
  } = useGetOperationAsync(props.match.params.idOperation);

  const {
    data: useVerifyRiskAcceptanceData,
    loading: useVerifyRiskAcceptanceLoading,
    error: useVerifyRiskAcceptanceError,
    status: useVerifyRiskAcceptanceStatus,
    request: useVerifyRiskAcceptanceRequest
  } = useVerifyRiskAcceptance(props.match.params.idOperation);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  const {
    loading: useUpdateDocumentsClausesLoading,
    request: useUpdateDocumentsClausesRequest,
  } = useUpdateDocumentsClausesSync(props.match.params.idOperation);

  const {
    loading: useRequestSompoGetInternalProcessNumberLoading,
    request: useRequestSompoGetInternalProcessNumberRequest,
  } = useRequestSompoGetInternalProcessNumber();

  const {
    data: useSaveQuestionnaireAnswerData,
    loading: useSaveQuestionnaireAnswerLoading,
    error: useSaveQuestionnaireAnswerError,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest,
  } = useSaveQuestionnaireAnswer(props?.match?.params?.idOperation);

  const {
    loading: useCalculateCancellationSyncLoading,
    request: useCalculateCancellationSyncRequest
  } = useCalculateCancellationSync(props.match.params.idOperation);

  const {
    loading: useRequestSompoGetInstallmentsLoading,
    request: useRequestSompoGetInstallmentsRequest,
  } = useRequestSompoGetInstallments();

  const {
    loading: useSaveQuestionnaireAnswerSyncLoading,
    request: useSaveQuestionnaireAnswerSyncRequest,
  } = useSaveQuestionnaireAnswerSync(props?.match?.params?.idOperation);

  useEffect(() => {
    updateIsLoadingStatus(
      useGetDocumentsLoading ||
      useGetOperationLoading ||
      useResetOperationStateLoading ||
      useRecalculateSyncLoading ||
      useVerifyRiskAcceptanceLoading ||
      useGetQuestionnairesAnswersLoading ||
      useGetDocumentsExpiredLoading ||
      useGenerateQuoteLoading ||
      useUpdateDocumentsClausesLoading ||
      useUpdateOperationLoading ||
      useComissionRateLoading ||
      useRequestSompoGetInternalProcessNumberLoading ||
      clausesLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useCalculateCancellationSyncLoading ||
      useRequestSompoGetInstallmentsLoading ||
      useSaveQuestionnaireAnswerSyncLoading
    )
  }, [
    useGetDocumentsLoading,
    useRecalculateSyncLoading,
    useGetOperationLoading,
    useResetOperationStateLoading,
    useVerifyRiskAcceptanceLoading,
    useGetQuestionnairesAnswersLoading,
    useGetDocumentsExpiredLoading,
    useGenerateQuoteLoading,
    useUpdateDocumentsClausesLoading,
    useUpdateOperationLoading,
    useComissionRateLoading,
    useRequestSompoGetInternalProcessNumberLoading,
    clausesLoading,
    useSaveQuestionnaireAnswerLoading,
    useCalculateCancellationSyncLoading,
    useRequestSompoGetInstallmentsLoading,
    useSaveQuestionnaireAnswerSyncLoading
  ]);

  const SECTIONS = {
    QUOTE_LETTER: { name: 'QUOTE_LETTER', isMultiple: false, isRisk: false },
    PLANS: { name: 'PLANS', isMultiple: false, isRisk: false },
    PLANS_PAYMENT: { name: 'PLANS_PAYMENT', isMultiple: false, isRisk: false }
  };

  const getQuoteQuestionnaire = async () => {
    fitinsur.setAuthToken(authContext.token);
    let response = await fitinsur.requestProductsList().then(v => v.json())
    if (response.ret_code != 200) return;
    let product;
    response.ret_value.map(v => {
      if (v.ID_PRODUCT === Number(props.match?.params?.idProduct)) {
        product = v.PRODUCT_NAME;
      }
    });
    setProductName(product);
  }

  const handleSelectDeductible = deductible => {
    formikRef.current.setFieldValue('optionDeductible', String(deductible || 0))

    const idProductPlan = fullCoverageList?.coverageCalcList && isNumber(deductible) ?
      fullCoverageList.coverageCalcList[deductible]?.idProductPlan : null;

    setIdProductPlan(idProductPlan);

    if (idProductPlan) {
      useRecalculateSyncRequest(
        {
          recalculateParameters: recalculateParameters.current,
          idProductPlanSelected: idProductPlan
        },
        { draft: true }
      );
    }
  };

  const validateCoverageSelection = (selectedIndex = null) => {
    const indicesToCheck = selectedIndex !== null ? [selectedIndex] : coverageCalcList.map((_, index) => index);

    for (const index of indicesToCheck) {
      const currentCalculation = coverageCalcList[index];
      if (!currentCalculation || !currentCalculation.coverageItems.find(item => !item.coverageDisabled && [2621, 2622, 1507].includes(item.idCoverage))) {
        currentCalculation.coverageItems.filter(item => [2621, 2622, 1507].includes(item.idCoverage)).map(item => mc.error(item.coverageName));
        mc.error(`Selecione uma das coberturas abaixo para prosseguir:`);
        return false;
      }
    }

    if (operation?.document?.documentMetadata?.documentExpireDate && new Date(operation?.document?.documentMetadata?.documentExpireDate) < new Date()) {
      mc.error(`Cotação vencida. Por favor, gere novamente a cotação.`);
      return false;
    }

    return true;
  };

  const handleGetQuote = async (documentCoverageList, previousCalculation, indexCoverageCalcList) => {
    const chosenDeductible = isNumber(indexCoverageCalcList) ?
      indexCoverageCalcList : formikRef.current?.values?.optionDeductible;

    let calculations = documentCoverageList.coverageCalcList[0].coverageCalc ?
      documentCoverageList.coverageCalcList[chosenDeductible].coverageCalc :
      documentCoverageList.coverageCalcList;

    calculations = calculations.map((calculation, index) => {
      calculation.productPlanName = documentCoverageList.coverageCalcList[0].coverageCalc ?
        documentCoverageList.coverageCalcList[chosenDeductible].idProductPlanName :
        documentCoverageList.idProductPlanName;
      calculation.idProductPlan = documentCoverageList.coverageCalcList[0].coverageCalc ?
        documentCoverageList.coverageCalcList[chosenDeductible].idProductPlan :
        documentCoverageList.idProductPlan;
      calculation.option = index;
      calculation.deductibleDescription = String(calculation.deductibleDescription || 0.0);
      calculation.coverageComissionRate = (parseNumber(calculation.coverageComissionRate || 0.0) * 100).toFixed(5);

      calculation.coverageItems = calculation.coverageItems.map((coverage) => {
        coverage.coveragePremium = String(coverage.coveragePremium || 0.0);
        coverage.coveragePremiumDiscountLess = String(coverage.coveragePremiumDiscountLess || 0.0);
        coverage.coveragePremiumTaxLess = String(coverage.coveragePremiumTaxLess || 0.0);
        coverage.coveragePremiumDiscountRate = ((coverage.coveragePremiumDiscountRate || 0.0) * 100).toFixed(
          +props.match?.params?.idProduct === 9004 ? 6 : 2
        );
        coverage.coverageMaxLimClaimGuideline = String(coverage.coverageMaxLimClaimGuideline || 0.0);
        coverage.coverageDisabled = coverage.coverageDisabled;
        coverage.coverageLimit = String(coverage.coverageLimit ? parseNumber(coverage.coverageLimit || 0.0) : parseNumber(calculation.coverageLimit));
        coverage.deductibleDescription = String(coverage.deductibleDescription ? coverage.deductibleDescription : "");
        coverage.coverageMaxLimClaim = String(coverage.coverageMaxLimClaim ? parseNumber(coverage.coverageMaxLimClaim || 0.0) : parseNumber(calculation.coverageMaxLimClaim));
        coverage.coverageMaxLimClaimRate = (coverage.coverageMaxLimClaimRate ?
          parseNumber(coverage.coverageMaxLimClaimRate || 0.0) * 100 :
          (coverage.coverageMaxLimClaim / coverage.coverageLimit) * 100).toFixed(2);

        return coverage;
      });

      calculation.coverageItems = calculation.coverageItems.sort((a, b) => a.coverageDomain - b.coverageDomain)

      return calculation;
    });

    const endorsementCoverageAmount = Number((calculations[0].adjustmentCoverageAmount || 0).toFixed(2));
    const endorsementCoverageAmountRaw = Number((calculations[0].adjustmentCoverageAmount || 0));
    const coverageRetentionRate = (calculations[0].coverageRetentionRate || 0);
    const coverageRetentionAmount = Number((calculations[0].coverageRetentionAmount || 0).toFixed(2));
    const coverageRetentionRatePeriod = (calculations[0].coverageRetentionRatePeriod || 0);
    const hasPreviousDiffMinimumPremiumIssued = calculations[0]?.hasPreviousDiffMinimumPremiumIssued;

    const endorsementCoverageAmountAnswer = questionnaire.find(
      qst => qst.idQuestion === 3522
    )?.answer;
    const changeInValueEndorsementCoverageAmount = (
      endorsementCoverageAmountAnswer &&
      Number(endorsementCoverageAmountAnswer) != endorsementCoverageAmountRaw
    );

    let flagReloadClauses = false;
    const overwriteQst = {};

    setQuestionnaire(questionnaire.map(qst => {
      if (qst.idQuestion === 3522) {
        qst.answer = String(endorsementCoverageAmountRaw);
        formikRef.current?.setFieldValue(qst.key, qst.answer);

        if (operation?.idDomain === 400) {
          overwriteQst[qst.idQuestion] = endorsementCoverageAmount;
        } else if (operation?.idDomain === 398) {
          //if (changeEndorsmentPremium.current) {
          // const idx = questionMappingAdhocParameters.current.findIndex(item => item.mapName === 'ENDORSEMENT_PREMIUM');
          // if (idx !== -1) {
          //   questionMappingAdhocParameters.current[idx].mapValue = endorsementCoverageAmount;
          // } else {
          //   questionMappingAdhocParameters.current.push({ mapName: 'ENDORSEMENT_PREMIUM', mapValue: endorsementCoverageAmount });
          // }
        }
      }

      if (qst.idQuestion === 3537) {
        qst.answer = String(coverageRetentionAmount);
        formikRef.current?.setFieldValue(qst.key, qst.answer);
      }

      if (qst.idQuestion === 3535) {
        const proRataQuestion = questionnaire.find(q => q.idQuestion === 3533);
        qst.visibleQuestion = proRataQuestion?.idAnswerOption === 9075;
      }

      if (qst.idQuestion === 3536) {
        const proRataQuestion = questionnaire.find(q => q.idQuestion === 3533);
        qst.visibleQuestion = proRataQuestion?.idAnswerOption === 9075;
        qst.answer = String(coverageRetentionRate * 100);
        formikRef.current?.setFieldValue(qst.key, qst.answer);
      }

      if (qst.idQuestion === 3521 && operation.idDomain === 398) {
        qst.sequenceQuestion === 999999;
      }

      if (qst.idQuestion === 3531 && operation.idDomain === 398) {
        qst.answer = String(calculations[0].previousCoverageAmount || 0);
        formikRef.current?.setFieldValue(qst.key, qst.answer);
      }

      if (qst.idQuestion === 3523) {
        // if (operation?.idDomain === 400) {
        //   qst.behaviorObject.isReadOnly = false;
        // }

        let idAnswerOption = endorsementCoverageAmount === 0 ? 9064 : endorsementCoverageAmount > 0 ? 9066 : 9065;
        const answerOption = qst.answerOptions.find(opt => opt.idAnswerOption === idAnswerOption);

        if (
          (
            qst.idAnswerOption !== answerOption.idAnswerOption ||
            (answerOption.idAnswerOption === 9065 && changeInValueEndorsementCoverageAmount)
          ) && operation?.idDomain === 400
        ) {
          overwriteQst[qst.idQuestion] = {
            answer: answerOption.dsAnswerOption,
            idAnswerOption: answerOption.idAnswerOption
          };
          flagReloadClauses = true;
        }

        qst.answer = answerOption.dsAnswerOption;
        qst.idAnswerOption = answerOption.idAnswerOption;

        formikRef.current?.setFieldValue(qst.key, {
          idAnswerOption: qst.idAnswerOption,
          dsAnswerOption: qst.answer,
          resultValue: null
        });
      }

      if (qst.idQuestion === 3535) {
        const answerOption = qst.answerOptions.find(opt => opt.dsAnswerOption === coverageRetentionRatePeriod);
        if (answerOption) {
          qst.answer = answerOption.dsAnswerOption;
          qst.idAnswerOption = answerOption.idAnswerOption;

          formikRef.current?.setFieldValue(qst.key, {
            idAnswerOption: qst.idAnswerOption,
            dsAnswerOption: qst.answer,
            resultValue: null
          });
        }
      }

      if ([3524, 3525, 3526, 3527, 3528].includes(qst.idQuestion)) {
        qst.visibleQuestion = endorsementCoverageAmount < 0;
        qst.behaviorObject.sectionName = "PLANS_PAYMENT";
        qst.sequenceQuestion = 9999;
      }

      // if (qst.idQuestion === 2437 && hasPreviousDiffMinimumPremiumIssued === false) {
      //   if (
      //     (operation?.idDomain === 398 && calculations[0]?.coverageAmount < 0) ||
      //     operation?.idDomain === 400
      //   ) {
      //     qst.visibleQuestion = true;
      //   }
      // }

      return qst;
    }));

    if (flagReloadClauses) {
      setOverwriteQstValues(overwriteQst);
      setReloadClauses(flagReloadClauses);
    }

    if (!idProductPlan) {
      handleCalculateCancellation(questionnaire, calculations);
    }
    let currentIdProductPlan = [400, 398].includes(operation.idDomain) && operation?.idProductPlan ? operation.idProductPlan : calculations[0].idProductPlan;
    setIdProductPlan(currentIdProductPlan);
    if (previousCalculation) {
      formikRef.current?.setFieldValue('previousCalculationList', calculations);
      setPreviousCoverageCalcList(calculations);
    } else {
      formikRef.current?.setFieldValue('calculationList', calculations);
      setCoverageCalcList(calculations);
    }
  }

  const parseNumber = (value) => {
    if (typeof (value) === 'string') {
      if (value.startsWith('%')) return Number(value.replaceAll('%', '').replaceAll(',', '.'))

      return Number(value.replaceAll('R$', '').replaceAll('.', '').replaceAll(',', '.'))
    }
    return value
  }

  useEffect(() => {
    if (!clausesLoading) {
      setReloadClauses(null);
      setOverwriteQstValues({});
    }
  }, [clausesLoading]);

  useEffect(() => {
    if (useGetDocumentsStatus === 200) {
      //Quote Document
      const [quoteRequestDocument] = useGetDocumentsData.value;
      setFullCoverageList(quoteRequestDocument.documentCoverageList);
      setHasCoverageCalc(quoteRequestDocument.documentCoverageList.coverageCalcList[0].coverageCalc);
      const coverageCalcList = quoteRequestDocument.documentCoverageList?.coverageCalcList;

      //Franchises
      let indexCoverageCalcList = null;
      if (coverageCalcList) {
        indexCoverageCalcList = coverageCalcList.findIndex(
          coverage => coverage.idProductPlan === operation?.operationMetadata?.idProductPlanSelected
        );

        if (indexCoverageCalcList !== -1) {
          formikRef.current.setFieldValue('optionDeductible', String(indexCoverageCalcList))
        } else {
          indexCoverageCalcList = null;
        }

        const deductibles = coverageCalcList.map((cov, index) => {
          const coverage = cov.coverageCalc ? cov.coverageCalc[0] : '';
          return {
            value: String(index),
            label: coverage.deductibleDescription
          }
        }).filter((item, index, self) => index === self.findIndex(
          arr => arr.label === item.label && arr.label === item.label
        ));

        setGroupDeductible(deductibles);
      }

      handleGetQuote(quoteRequestDocument.documentCoverageList, null, indexCoverageCalcList);
    }
  }, [useGetDocumentsStatus])

  useEffect(() => {
    if (!useGetDocumentsExpiredStatus) return;
    if (useGetDocumentsExpiredStatus === 200) {
      const quoteDocumentsExpired = useGetDocumentsExpiredData.value?.find(document => document.idDomainStatus === 19);
      if (quoteDocumentsExpired) handleGetQuote(quoteDocumentsExpired.documentCoverageList, true);
    }
  }, [useGetDocumentsExpiredStatus])

  const handleOperationInfo = () => {
    useGetOperationRequest(null, { loadLastDocument: true }).then(response => {
      let operationData;
      if (response.status === 200) {
        operationData = response.data?.value;
        setOperation(operationData);
        setIsBound([5, 2, 6, 133, 158, 187, 263, 104, 99, 159, 140, 177, 188, 198, 176, 403].includes(operationData?.idDomainStatus));
        useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operationData?.idDomainStatus });

        if (operationData.idDomain === 400) {
          useRecalculateSyncRequest(
            {
              recalculateParameters: recalculateParameters.current,
              questionMappingAdhoc: questionMappingAdhocParameters.current,
              idProductPlanSelected: operationData.idProductPlan
            },
            { draft: true }
          );
        }
      }
    });
  }

  useEffect(() => {
    if (getQuestionnaire.current) return;
    if (isEmpty(permissions)) return;

    handleOperationInfo();
    // useGetDocumentsRequest(null, { idDomain: 261 });
    // useGetDocumentsExpiredRequest(null, { idDomain: 261, expiredDocumentsOnly: true });
    useVerifyRiskAcceptanceRequest(null, { draft: true });
    // useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operationData?.idDomainStatus });
    getQuoteQuestionnaire();
    formikRef.current.setFieldValue('optionDeductible', String(0))

    getQuestionnaire.current = true
  }, [permissions])

  useEffect(() => {
    if (useComissionRateStatus === 200) {
      const { commissionValue, minCommissionValue } = useComissionRateData;

      setMinCommissionValue(minCommissionValue * 100);
      setMaxCommissionValue(commissionValue * 100);
    }
  }, [useComissionRateStatus]);

  useEffect(() => {
    if (useRecalculateSyncStatus === 200) {
      handleGetQuote(useRecalculateSyncData?.value)
    }
  }, [useRecalculateSyncStatus]);

  useEffect(() => {
    if (idProductPlan) {
      useComissionRateRequest(null, {
        idProduct: props.match?.params?.idProduct,
        idProductPlanSelected: idProductPlan
      });
    }
  }, [idProductPlan])

  useEffect(() => {
    const loadQuestionnaire = async () => {
      if (useVerifyRiskAcceptanceStatus === 200 && useGetQuestionnairesAnswersStatus === 200) {
        const { riskDescription } = useVerifyRiskAcceptanceData?.value;

        let questionnaire = [];
        setQuestionnaire(questionnaire);
        await new Promise(resolve => setTimeout(() => resolve(), 500))

        questionnaire = [
          ...useGetQuestionnairesAnswersData?.value.persons,
          ...useGetQuestionnairesAnswersData?.value.operations,
          ...useGetQuestionnairesAnswersData?.value.payments,
          ...useGetQuestionnairesAnswersData?.value.risks
        ];

        const forceAnalysis = ([398, 400].includes(operation?.idDomain) && HAS_APPROVAL_AND_REJECT_PERMISSION) ||
          questionnaire.find(question => question.idQuestion === 3456)?.idAnswerOption === 8993;

        setQuestionnaire(questionnaire.map(qst => {
          if ([3524, 3525, 3526, 3527, 3528].includes(qst.idQuestion)) {
            qst.behaviorObject.sectionName = "PLANS_PAYMENT";
            qst.sequenceQuestion = 9999;
          }

          return qst;
        }).sort((a, b) => a.sequenceQuestion - b.sequenceQuestion));

        setIsInAnalysis(riskDescription === 'Analisar' || forceAnalysis);
        useGetDocumentsRequest(null, { idDomain: 261 });

        const finishedAnalysis = questionnaire.find(qst => qst.idQuestion === 3457)?.idAnswerOption === 8995;
        if (finishedAnalysis) {
          setOperation({
            ...operation, document: {
              ...operation.document,
              idDomainStatus: 16
            }
          });
        }
      }
    }
    loadQuestionnaire();
  }, [useVerifyRiskAcceptanceStatus, useGetQuestionnairesAnswersStatus]);

  const handlePermissionEdit = () => {
    return !(
      isBound || !isInAnalysis ||
      operation?.document?.idDomainStatus === 20 ||
      (!HAS_APPROVAL_AND_REJECT_PERMISSION && operation?.document?.idDomainStatus === 19)
    )
  }

  useEffect(() => {
    function resize() {
      if (window.innerWidth < 576) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
    resize();
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    }
  }, []);


  const buildValidation = (draft) => {
    const validationSchema = {};

    const questionnaire = handleSaveQuestionnaireAnswer(props.match.params.idOperation, true);

    let allQuestions = [...questionnaire];
    for (const question of allQuestions) {
      if (question.childrenQuestions?.length) allQuestions = [...allQuestions, ...question.childrenQuestions]
    }

    for (const question of allQuestions) {
      if (draft && ![1634, 1776, 1637].includes(question.idQuestion)) continue;
      if ([614].includes(question?.idDomainQuestion)) continue;
      if (!question?.key) continue;

      question?.childrenQuestions?.map(item => {
        if (item.visibleQuestion && item.fieldMask?.type == 'phone' && item.behaviorObject?.isRequired) {
          validationSchema[item.key] = yup.string().test({
            name: "answer-validation",
            message: "Telefone inválido",
            test: (value) => !!value && value.length >= 10
          })
        } else if (item.visibleQuestion && item.behaviorObject?.fieldMask == 'email') {
          if (item.answer) {
            validationSchema[item.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
          } else {
            if (item.behaviorObject?.isRequired) {
              validationSchema[item.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
            } else {
              validationSchema[item.key] = yup.string().notRequired();
            }
          }
        } else {
          validationSchema[item.key] = item.visibleQuestion && item.behaviorObject?.isRequired
            ? yup.string().test("answer-validation", "Campo obrigatório", function (value) {
              return !!item.answer;
            }) : yup.string().notRequired();
        }
      })

      if (question.visibleQuestion && question.behaviorObject?.isRequired && question.fieldMask?.type == 'phone') {
        validationSchema[question.key] = yup.string().test({
          name: "answer-validation",
          message: "Telefone inválido",
          test: (value) => !!value && value.length >= 10
        })
      } else if (question.visibleQuestion && question.behaviorObject?.fieldMask == 'email') {
        if (question.answer) {
          validationSchema[question.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
        } else {
          if (question.behaviorObject?.isRequired) {
            validationSchema[question.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
          } else {
            validationSchema[question.key] = yup.string().notRequired();
          }
        }
      } else {
        validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
          ? yup.string().test("answer-validation", "Campo obrigatório", function (value) {
            return !!question.answer;
          }) : yup.string().notRequired();
      }
    }

    return yup.object().shape(validationSchema);
  }

  const handleGenerateQuote = async (values) => {

    buildValidation().validate(values, { abortEarly: false })
      .then(async () => {
        handleSaveQuestionnaireAnswer(props.match?.params?.idOperation)
      })
      .catch((e) => {
        onValidationError(e, mc, formikRef, questionnaire, [])
      })
  }


  const handleSaveQuestionnaireAnswer = (idOperation, onlyQuestions, formattedGroups) => {
    const body = { questionnaireAnswers: cloneDeep(questionnaire) };
    for (const [key, section] of Object.entries(SECTIONS)) {
      if (section.isMultiple) {
        let multipleFields = []
        switch (section.name) {
          default:
            multipleFields = [];
            break;
        }

        multipleFields.map(group => {
          if (group?.length) {
            const rootQuestion = group.find(question => !question.idQuestionRoot);
            const childrenQuestions = group.filter(question => question.idQuestionRoot);
            rootQuestion.childrenQuestions = childrenQuestions;
            if (!onlyQuestions || formattedGroups) {
              body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
            } else {
              body.questionnaireAnswers = [...body.questionnaireAnswers, ...group];
            }
          }
        })
      }
    }

    body.questionnaireAnswers = body.questionnaireAnswers.filter(question => {
      return (question?.behaviorObject?.sectionName && SECTIONS[question?.behaviorObject?.sectionName]);
    });

    let childrenQuestionIds = [];
    for (const question of body.questionnaireAnswers) {
      if (question) {
        if (
          (
            question.idDomainQuestion === 270 ||
            question.idDomainQuestion === 271 ||
            (question.idDomainQuestion === 44 && typeof question.answer === 'object')
          ) && question.answer
        ) {
          try {
            question.answer = JSON.stringify(question.answer)
          } catch (e) {
          }
        }

        if (SECTIONS[question.behaviorObject?.sectionName] && SECTIONS[question.behaviorObject?.sectionName].isMultiple) {
          if (question?.childrenQuestions?.length) {
            const idQuestions = question.childrenQuestions.map(question => question.idQuestion);
            childrenQuestionIds = [...childrenQuestionIds, ...idQuestions];
          }
        } else {
          question.childrenQuestions = [];
        }
      }
    }

    body.questionnaireAnswers = body.questionnaireAnswers.filter(v =>
      !childrenQuestionIds.includes(v.idQuestion) &&
      v.idQuestion !== 1812
    );

    if (onlyQuestions) return body.questionnaireAnswers;

    useSaveQuestionnaireAnswerRequest(body.questionnaireAnswers);
  }

  // Helper: Upsert (Update ou Insert) de coverage derivada em recalculateParameters
  const upsertCoverageParameter = (index, coverageData, idProductPlan) => {
    const hasParameter = recalculateParameters.current.find(
      (option) => option.coverageCalcIndex === index
    );

    if (hasParameter) {
      if (hasParameter.coverageItens) {
        const hasCoverage = hasParameter.coverageItens.find(
          (coverage) => coverage.idCoverage === coverageData.idCoverage
        );
        if (hasCoverage) {
          // UPDATE: atualiza cobertura existente
          Object.assign(hasCoverage, coverageData);
        } else {
          // INSERT: adiciona nova cobertura ao array existente
          hasParameter.coverageItens.push(coverageData);
        }
      } else {
        hasParameter.coverageItens = [coverageData];
      }
    } else {
      // INSERT: cria novo parâmetro com a cobertura
      recalculateParameters.current.push({
        coverageCalcIndex: index,
        coverageItens: [coverageData],
        idProductPlan
      });
    }
  };

  const onRecalculateItem = async (value, index, idCoverage, fieldName, resetFieldName = 'dummyField') => {
    const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);
    const mapValue = [0, 0, 0]
    mapValue[index] = value;
    const questionMappingAdhoc = []
    if (fieldName === 'coverageLimit') {
      questionMappingAdhoc.push(
        {
          mapName: "mapQuestionLMI",
          mapValue
        }
      )

      // Quando o usuario edita diretamente uma das 3 coberturas derivadas,
      // injetar os adhocs de guideline (normalmente produzidos pelo auto-calc)
      if ([302, 976, 2624].includes(idCoverage)) {
        const currentCoverage = coverageCalcList[index];
        if (currentCoverage && currentCoverage.coverageItems) {
          const pendingEntryAdhoc = recalculateParameters.current.find(p => p.coverageCalcIndex === index);
          const isDisabledAdhoc = (idCovg) => {
            const p = pendingEntryAdhoc?.coveragesDisabled?.find(c => c.idCoverage === idCovg);
            if (p !== undefined) return p.value;
            return !!currentCoverage.coverageItems.find(item => item.idCoverage === idCovg)?.coverageDisabled;
          };
          if ([302, 976].includes(idCoverage)) {
            const DERIVED = [302, 976, 2624];
            const maxLim = Math.max(0, ...currentCoverage.coverageItems
              .filter(item => !DERIVED.includes(item.idCoverage) && !isDisabledAdhoc(item.idCoverage))
              .map(item => {
                const pending = pendingEntryAdhoc?.coverageItens?.find(c => c.idCoverage === item.idCoverage);
                return parseNumber(pending?.coverageLimit ?? item.coverageLimit ?? 0);
              })
            );
            questionMappingAdhoc.push({ mapName: "mapMaxLimAllCoverages", mapValue: maxLim });
          }
          if (idCoverage === 2624) {
            const obras = currentCoverage.coverageItems.find(item => item.idCoverage === 2622);
            if (obras) {
              const pendingObras = pendingEntryAdhoc?.coverageItens?.find(c => c.idCoverage === 2622);
              const obrasLim = parseNumber(pendingObras?.coverageLimit ?? obras.coverageLimit ?? 0);
              questionMappingAdhoc.push({ mapName: "mapObrasLim", mapValue: obrasLim });
            }
          }
        }
      }
    }

    let idProductPlan = null;
    if (Array.isArray(coverageCalcList) && coverageCalcList[index]) {
      idProductPlan = coverageCalcList[index].idProductPlan || null;
    }

    if (hasParameter) {
      if (hasParameter.coverageItens) {
        const hasCoverage = hasParameter.coverageItens.find((coverage) => coverage.idCoverage === idCoverage);
        if (hasCoverage) {
          hasCoverage[fieldName] = value;
          hasCoverage[resetFieldName] = null;
          hasCoverage.questionMappingAdhoc = questionMappingAdhoc;
        } else {
          hasParameter.coverageItens.push({ idCoverage, [fieldName]: value, [resetFieldName]: null, questionMappingAdhoc });
        }
      } else {
        hasParameter.coverageItens = [{ idCoverage, [fieldName]: value, [resetFieldName]: null, questionMappingAdhoc }];
      }
    } else {
      recalculateParameters.current.push({
        coverageCalcIndex: index,
        coverageItens: [{
          idCoverage, [fieldName]: value,
          [resetFieldName]: null,
          questionMappingAdhoc
        }],
        idProductPlan
      });
    }

    // Lógica de auto-cálculo: executada ao editar qualquer cobertura exceto 302, 976 e 2624
    if (fieldName === 'coverageLimit' && idCoverage !== 302 && idCoverage !== 976 && idCoverage !== 2624) {
      const currentCoverage = coverageCalcList[index];
      if (currentCoverage && currentCoverage.coverageItems) {
        // Verifica se uma cobertura está desabilitada, priorizando estado pendente sobre stale
        const pendingEntry = recalculateParameters.current.find(p => p.coverageCalcIndex === index);
        const isCoverageDisabled = (idCovg) => {
          const pending = pendingEntry?.coveragesDisabled?.find(c => c.idCoverage === idCovg);
          if (pending !== undefined) return pending.value;
          return !!currentCoverage.coverageItems.find(item => item.idCoverage === idCovg)?.coverageDisabled;
        };

        // Coberturas derivadas: excluídas do maxCoverageLimit de 302
        const DERIVED_COVERAGES = [302, 976, 2624, 11676];

        // maxCoverageLimit: usado por 302 (exclui derivadas)
        const coverageLimits = currentCoverage.coverageItems
          .filter(item => item.idCoverage !== idCoverage && !DERIVED_COVERAGES.includes(item.idCoverage) && !isCoverageDisabled(item.idCoverage))
          .map(item => parseNumber(item.coverageLimit || 0));
        coverageLimits.push(parseNumber(value || 0));
        const maxCoverageLimit = Math.max(...coverageLimits);

        // maxCoverageLimitBasic: usado por 976 (apenas coberturas básicas, coverageDomain === 1)
        const editedItem = currentCoverage.coverageItems.find(item => item.idCoverage === idCoverage);
        const basicLimits = currentCoverage.coverageItems
          .filter(item => item.idCoverage !== idCoverage && item.coverageDomain === 1 && !isCoverageDisabled(item.idCoverage))
          .map(item => parseNumber(item.coverageLimit || 0));
        if (editedItem?.coverageDomain === 1) basicLimits.push(parseNumber(value || 0));
        const maxCoverageLimitBasic = Math.max(0, ...basicLimits);

        // --- Tratamento para cobertura 302 ---
        const coverage302 = currentCoverage.coverageItems.find(item => item.idCoverage === 302);
        const coverage302Rate = coverage302 ? Number(coverage302.coverageMaxLimClaimRate || 0) / 100 : 0.2;
        const calculatedValue302 = maxCoverageLimit * coverage302Rate;
        if (calculatedValue302 > 0 && !isCoverageDisabled(302)) {
          const mapValue302 = [0, 0, 0];
          mapValue302[index] = calculatedValue302;
          const coverage302Data = {
            idCoverage: 302,
            coverageLimit: calculatedValue302.toString(),
            [resetFieldName]: null,
            questionMappingAdhoc: [
              { mapName: "mapQuestionLMI", mapValue: mapValue302 },
              { mapName: "mapMaxLimAllCoverages", mapValue: maxCoverageLimit }
            ]
          };
          upsertCoverageParameter(index, coverage302Data, idProductPlan);
        }

        // --- Tratamento para cobertura 976 ---
        const coverage976Rate = 0.5;
        const calculatedValue976 = maxCoverageLimitBasic * coverage976Rate;
        if (calculatedValue976 > 0 && !isCoverageDisabled(976)) {
          const mapValue976 = [0, 0, 0];
          mapValue976[index] = calculatedValue976;
          const coverage976Data = {
            idCoverage: 976,
            coverageLimit: calculatedValue976.toString(),
            [resetFieldName]: null,
            questionMappingAdhoc: [
              { mapName: "mapQuestionLMI", mapValue: mapValue976 },
              { mapName: "mapMaxLimAllCoverages", mapValue: maxCoverageLimitBasic }
            ]
          };
          upsertCoverageParameter(index, coverage976Data, idProductPlan);
        }

        // --- Tratamento para cobertura 2624: 20% da cobertura 2622 com cap de R$ 400.000 ---
        const coverage2622 = currentCoverage.coverageItems.find(item => item.idCoverage === 2622);
        if (coverage2622 && !isCoverageDisabled(2624)) {
          // Se estiver editando a própria 2622, usar o value novo, senão usar o limite atual
          const coverage2622Limit = idCoverage === 2622 
            ? parseNumber(value || 0) 
            : parseNumber(coverage2622.coverageLimit || 0);
          const coverage2624Rate = 0.2;
          const calculatedValue2624 = coverage2622Limit * coverage2624Rate;
          
          if (calculatedValue2624 > 0) {
            const mapValue2624 = [0, 0, 0];
            mapValue2624[index] = calculatedValue2624;
            const coverage2624Data = {
              idCoverage: 2624,
              coverageLimit: calculatedValue2624.toString(),
              [resetFieldName]: null,
              questionMappingAdhoc: [
                { mapName: "mapQuestionLMI", mapValue: mapValue2624 },
                { mapName: "mapObrasLim", mapValue: coverage2622Limit }
              ]
            };
            upsertCoverageParameter(index, coverage2624Data, idProductPlan);
          }
        }
      }
    }

    useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
  }

  const onRecalculate = async (value, index, fieldName) => {
    const hasParameter = recalculateParameters.current.find(
      (option) => option.coverageCalcIndex === index && option.idProductPlan === idProductPlan
    );

    if (hasParameter) {
      hasParameter[fieldName] = value;
    } else {
      recalculateParameters.current.push({
        coverageCalcIndex: index, [fieldName]: value, idProductPlan
      })
    }
    useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
  }

  useEffect(() => {
    if (useSaveQuestionnaireAnswerStatus === 200) {
      if (!goToNextPage.current) {
        mc.success('informações salvas com sucesso!');
        return history.push(operation?.idDomain === 26 || !operation?.idDomain ? '/list' : '/polices');
      }

      const questionnaireUpdated = handleSaveQuestionnaireAnswer(props.match.params.idOperation, true);

      const finishedQuestion = questionnaireUpdated.find(q => q.idQuestion == 1427 || q.idQuestion == 3457);
      const finishedAnalisys = finishedQuestion?.idAnswerOption === 8995 || finishedQuestion?.idAnswerOption === 6872;

      useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operation?.idDomainStatus });

      const hasInternalProcessNumberAnswer = questionnaire.find(qst => qst.idQuestion === 3476)?.answer;
      console.log("hasInternalProcessNumberAnswer", hasInternalProcessNumberAnswer)
      if (!hasInternalProcessNumberAnswer) {
        useRequestSompoGetInternalProcessNumberRequest({ idOperation: props?.match?.params?.idOperation })
          .then(async (response) => {
            if (response.status !== 200) {
              return mc.error('Ocorreu um erro na requisição do sistema externo');
            }

            useGenerateQuoteRequest({ selectedClausesAdHock: selectedClauses, idDomainStatus: finishedAnalisys ? 16 : 19, idProductPlanSelected: idProductPlan }).then(async (response) => {
              if (response.status == 200) {
                if (operation?.idDomain === 400) {
                  await useUpdateOperationRequest({ idDomainStatus: 151 });
                }
                return history.push(`/quote/document/${props?.match?.params?.idProduct}/${props?.match?.params?.idOperation}`);
              }
            })
          }).catch((e) => {
            return mc.error('Ocorreu um erro na requisição do sistema externo');
          })
      } else {
        useGenerateQuoteRequest({ selectedClausesAdHock: selectedClauses, idDomainStatus: finishedAnalisys ? 16 : 19, idProductPlanSelected: idProductPlan }).then(async (response) => {
          if (response.status == 200) {
            if (operation?.idDomain === 400) {
              await useUpdateOperationRequest({ idDomainStatus: 151 });
            }
            return history.push(`/quote/document/${props?.match?.params?.idProduct}/${props?.match?.params?.idOperation}`);
          }
        })
      }
    }
  }, [useSaveQuestionnaireAnswerStatus]);

  const handleCalculateCancellation = async (questionnaire, calculations, forceRefreshTotalPaid = false) => {
    if (![400, 398].includes(operation?.idDomain) || finishedAnalysis || goToNextPage.current) return;

    const totalPaidQuestion = questionnaire.find(question => question.idQuestion === 3521);
    const totalPaidPersonalized = questionnaire.find(qst => qst.idQuestion === 3529);

    if (totalPaidQuestion) totalPaidQuestion.behaviorObject.isReadOnly = false;
    if ((!totalPaidQuestion.answer || !Number(totalPaidQuestion.answer)) || forceRefreshTotalPaid) {
      try {
        const response = await useRequestSompoGetInstallmentsRequest({ idOperation: props.match.params.idOperation });
        if (response.status === 200) {
          if (!response.data?.ret_value?.installments?.length) {
            mc.error('Não identificamos o pagamento do prêmio dessa Apólice. Consultar a Célula de Atendimento Comercial - CAC');
            totalPaidQuestion.behaviorObject.isReadOnly = false;

            const answerOption = totalPaidPersonalized?.answerOptions.find(
              opt => opt.idAnswerOption === 9062 //yes
            );

            if (answerOption) {
              totalPaidPersonalized.answer = answerOption.dsAnswerOption;
              totalPaidPersonalized.idAnswerOption = answerOption.idAnswerOption;
            }
          } else {
            totalPaidQuestion.answer = String(response.data?.ret_value?.totalPaid || 0);
            formikRef.current?.setFieldValue(totalPaidQuestion.key, totalPaidQuestion.answer);
            //totalPaidQuestion.behaviorObject.isReadOnly = true;

            const answerOption = totalPaidPersonalized?.answerOptions.find(
              opt => opt.idAnswerOption === 9063 //no
            );

            if (answerOption) {
              totalPaidPersonalized.answer = answerOption.dsAnswerOption;
              totalPaidPersonalized.idAnswerOption = answerOption.idAnswerOption;
            }
          }
          setQuestionnaire(questionnaire);
        }
      } catch (e) {
        //mc.error('Não identificamos o pagamento do prêmio dessa Apólice. Consultar a Célula de Atendimento Comercial - CAC');
        //totalPaidQuestion.behaviorObject.isReadOnly = false;

        const answerOption = totalPaidPersonalized?.answerOptions.find(
          opt => opt.idAnswerOption === 9062 //yes
        );

        if (answerOption) {
          totalPaidPersonalized.answer = answerOption.dsAnswerOption;
          totalPaidPersonalized.idAnswerOption = answerOption.idAnswerOption;
        }
        setQuestionnaire(questionnaire);
      }
    }

    if ([398].includes(operation?.idDomain)) return;

    let isProRata = false;
    const isProRataQuestion = questionnaire.find(question => question.idQuestion === 3533);
    if (isProRataQuestion?.idAnswerOption === 9074) {
      isProRata = true;
    }

    // let disregardMinimumPremium = false;
    // const disregardMinimumPremiumQst = questionnaire.find(qst => qst.idQuestion === 2437);
    // if (disregardMinimumPremiumQst?.idAnswerOption === 8158) {
    //   disregardMinimumPremium = true;
    // }

    const questionMappingAdhoc = [
      {
        "mapName": "mapQuestion3534",
        "mapValue": calculations[0].previousCoverageAmount
      },
      {
        "mapName": "mapQuestion3495",
        "mapValue": questionnaire.find(question => question.idQuestion === 3495)?.answer || moment(new Date()).format('YYYY-MM-DD')
      },
      {
        "mapName": "mapQuestion3533",
        "mapValue": questionnaire.find(question => question.idQuestion === 3533)?.idAnswerOption || 9075
      },
      {
        "mapName": "mapQuestion3521",
        "mapValue": Number(questionnaire.find(question => question.idQuestion === 3521)?.answer || 0)
      }
    ]

    // if (changeEndorsmentPremium.current) {
    //   questionMappingAdhoc.push({
    //     "mapName": "mapQuestion1843",
    //     "mapValue": Number(questionnaire.find(question => question.idQuestion === 1843)?.answer || 0)
    //   })
    // }

    await useCalculateCancellationSyncRequest({
      isProRata,
      idProductPlanSelected: operation.idProductPlan,
      questionMappingAdhoc
    });

    useGetDocumentsRequest(null, { idDomain: 261 });
  }

  async function handleVerifyPaymentOfEndorsementsToRefund(documentCoverageList) {
    let verifiedPayment = true;

    //Ref: issue 2450 - temporarily disabled
    if (![398].includes(operation?.idDomain)) return verifiedPayment;

    const isRefund = questionnaire.find(
      qst => qst.idQuestion === 3523
    )?.idAnswerOption === 9065;

    const coverageCalc = documentCoverageList?.coverageCalcList?.[0];
    const { previousCoverageAmount } = coverageCalc || {};

    const premiumPaid = parseFloat(questionnaire.find(qst => qst.idQuestion === 3521)?.answer || 0);

    const totalPremium = Math.trunc((previousCoverageAmount || 0) * 100) / 100;

    const policyNotPaid = Math.abs(Number((premiumPaid - totalPremium).toFixed(2))) > 0.01 && premiumPaid < totalPremium;

    // setQuestionnaire(questionnaire.map(qst => {
    //   if (qst.idQuestion === 2439) {
    //     const answerOption = qst.answerOptions.find(opt =>
    //       opt.idAnswerOption === (policyNotPaid ? 8161 : 8160)
    //     );

    //     if (answerOption) {
    //       qst.answer = answerOption.dsAnswerOption;
    //       qst.idAnswerOption = answerOption.idAnswerOption;
    //     }
    //   }
    //   return qst;
    // }));

    if (!isRefund) return verifiedPayment;

    let totalPaid = null;
    try {
      const response = await useRequestSompoGetInstallmentsRequest({ idOperation: props.match.params.idOperation });
      if (response.status === 200 && response.data?.ret_value?.installments?.length) {
        totalPaid = Math.trunc(parseFloat(response.data?.ret_value?.totalPaid || 0) * 100) / 100;
      }
    } catch (error) { }
    // if (isNumber(totalPaid) && Math.abs(Number((totalPaid - premiumPaid).toFixed(2))) > 0.01) {
    //   mc.error(`
    //     Valor do Prêmio Líquido Pago divergente do valor retornado pela API de parcelas, 
    //     use o ícone de atualização ao lado  do campo Prêmio Líquido Pago para sincronizar os valores.
    //   `);
    //   verifiedPayment = false;
    //   return verifiedPayment;
    // }

    if (policyNotPaid) {
      // mc.error(`
      //   Endosso ${operation?.idDomain === 400 ? 'de cancelamento' : 'com movimento'} não permitido. 
      //   Apólice possui pendências financeiras. 
      // `);
      //verifiedPayment = false;
    }
    return verifiedPayment;
  }

  return (
    <Layout
      title={"Analise da Cotação"}
      subtitle={`${operation?.productName || ""}`}
    >
      <Row>
        <Col>
          <StepNavigation
            stage={2}
            idOperation={props.match?.params?.idOperation}
            idProduct={props.match?.params?.idProduct}
            permissions={permissions}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <BrokingSummary
            history={history}
            idOperation={props.match?.params?.idOperation}
            idProduct={props.match?.params?.idProduct} />
        </Col>
      </Row>

      <Content>
        <Formik
          validateOnChange={false}
          innerRef={formikRef}
          initialValues={{ calculationList: [], comission: 0, defaultValueCoverageDisabled: 'N/A' }}
          validationSchema={validationSchema.current}
          enableReinitialize={true}
          onSubmit={() => true}
        >
          {({ values, setFieldValue, errors, setFieldError }) => {
            return (
              <Form onKeyDown={(e) => {
                if (e.key === 'Enter') e.preventDefault();
              }}>

                <CoverageContainer>
                  <NotesModal
                    title={'Informações Adicionais'}
                    textButtonConfirm={'Confirmar'}
                    textButtonCancel={'Cancelar'}
                    show={notesModal}
                    setModalShow={setNotesModal}
                    idOperation={props.match?.params?.idOperation}
                    idQuestion={1198}
                    functionCallback={async () => {
                      await useResetOperationStateRequest({ idDomainOrigin: 26 });
                      const { status } = await useUpdateOperationRequest({ idDomainStatus: 4 });
                      if (status === 200) history.push('/enquiries');
                    }}
                  />

                  {selectedOption != null && <DialogCalculation
                    show={true}
                    formikValues={values}
                    formikRef={formikRef}
                    setFieldValue={setFieldValue}
                    calcList={previousCoverageCalcList?.filter(calculations => calculations.coverageLimit)}
                    permissions={permissions}
                    selectedOption={selectedOption}
                    closeModal={() => {
                      setSelectedOption(null)
                    }}
                  />}

                  {isMobile
                    ? <MobileTable
                      formikValues={values}
                      formikRef={formikRef}
                      calcList={coverageCalcList.filter(calculations => calculations.coverageLimit)}
                      setFieldValue={setFieldValue}
                      history={history}
                      showAlterButton={isBound}
                      disabled={operation?.idDomain === 400 || isBound || !isInAnalysis || operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16 || (!HAS_APPROVAL_AND_REJECT_PERMISSION && operation?.document?.idDomainStatus === 19)}
                      newDisabled={operation?.idDomain === 400 || isBound || !isInAnalysis || operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16 || (!HAS_APPROVAL_AND_REJECT_PERMISSION && operation?.document?.idDomainStatus === 19)}
                      disabledCommision={
                        operation?.idDomain === 400 ||
                        isBound || (isInAnalysis && !HAS_APPROVAL_AND_REJECT_PERMISSION) || (isInAnalysis && (operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16))
                      }
                      permissions={permissions}
                      idOperation={props.match?.params?.idOperation}
                      idProduct={props.match?.params?.idProduct}
                      susepProcess={operation?.susepProcess || '-'}
                      disabledConfirm={
                        !HAS_EXECUTE_PERMISSION || isBound || (operation?.document?.idDomainStatus !== 16 && operation?.document?.idDomainStatus !== 20)
                      }
                      onConfirmPlanText={'CONTRATAR'}
                      showHistory={previousCoverageCalcList?.length}
                      showCoveragesAndExtensions={true}
                      onConfirmPlan={async (index) => {
                        try {
                          if (operation?.document?.documentMetadata?.documentExpireDate && new Date(operation?.document?.documentMetadata?.documentExpireDate) < new Date()) {
                            return mc.error(`Cotação vencida. Por favor, gere novamente a cotação.`);
                          }

                          const questionnaireData = handleSaveQuestionnaireAnswer(null, true);
                          await useSaveQuestionnaireAnswerSyncRequest(questionnaireData);
                          await useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operation?.idDomainStatus }).then(() => { });
                          await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, coverageOption: index, idProductPlanSelected: idProductPlan } });
                          await useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: false });
                          await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });

                          const hasInternalProcessNumberAnswer = questionnaire.find(qst => qst.idQuestion === 3476)?.answer;
                          if (!hasInternalProcessNumberAnswer) {
                            await useRequestSompoGetInternalProcessNumberRequest({ idOperation: operation?.idOperation })
                              .then(async (response) => {
                                if (response.status !== 200) {
                                  return mc.error('Ocorreu um erro na requisição do sistema externo');
                                }
                              }).catch((e) => {
                                return mc.error('Ocorreu um erro na requisição do sistema externo');
                              })
                          }

                          await useGenerateQuoteRequest({
                            selectedClausesAdHock: selectedClauses,
                            idDomainStatus: 20,
                            idProductPlanSelected: idProductPlan,
                            preferredOption: index
                          });

                          history.push({ pathname: `/payment-configuration/${props.match?.params?.idOperation}`, state: { option: index, idProductPlanSelected: idProductPlan } });
                        } catch (e) {
                          loading.stop();
                          return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                        }
                      }}
                      onRecalculate={onRecalculate}
                      handleCheckCoverage={(value, index, idCoverage) => {
                        const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);

                        if (hasParameter) {
                          if (hasParameter.coveragesDisabled) {
                            hasParameter.coveragesDisabled = hasParameter.coveragesDisabled.filter((idCov) => idCov.idCoverage != idCoverage);
                            hasParameter.coveragesDisabled.push({ idCoverage, value });
                          } else if (value) {
                            hasParameter.coveragesDisabled = [{ idCoverage, value }];
                          }
                        } else {
                          recalculateParameters.current.push({ coverageCalcIndex: index, coveragesDisabled: [{ idCoverage, value }], idProductPlan })
                        }

                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      onRecalculateItem={onRecalculateItem}
                      openHistoryModel={(index) => {
                        setSelectedOption(index)
                      }}
                      onSelectDeductible={(value) => handleSelectDeductible(value)}
                      onOptionsDeductible={groupDeductible}
                      hasCoverageCalc={hasCoverageCalc}
                      minComission={minCommissionValue}
                      maxComission={maxComissionValue}
                    />

                    : <Table
                      componentTypeRender={'singleProductPlan'}
                      formikValues={values}
                      formikRef={formikRef}
                      calcList={coverageCalcList.filter(calculations => calculations.coverageLimit)}
                      setFieldValue={setFieldValue}
                      history={history}
                      showAlterButton={isBound}
                      enableLmiAndSublimit={!isBound}
                      disabled={operation?.idDomain === 400 || isBound || !isInAnalysis || operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16 || (!HAS_APPROVAL_AND_REJECT_PERMISSION && operation?.document?.idDomainStatus === 19)}
                      newDisabled={operation?.idDomain === 400 || isBound || !isInAnalysis || operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16 || (!HAS_APPROVAL_AND_REJECT_PERMISSION && operation?.document?.idDomainStatus === 19)}
                      disabledCommision={
                        operation?.idDomain === 400 ||
                        isBound || (isInAnalysis && !HAS_APPROVAL_AND_REJECT_PERMISSION) || (isInAnalysis && (operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16))
                      }
                      permissions={permissions}
                      idDomainOperation={operation?.idDomain}
                      idOperation={props.match?.params?.idOperation}
                      idProduct={props.match?.params?.idProduct}
                      susepProcess={operation?.susepProcess || '-'}
                      disabledConfirm={
                        !HAS_EXECUTE_PERMISSION || isBound || (operation?.document?.idDomainStatus !== 16 && operation?.document?.idDomainStatus !== 20)
                      }
                      onConfirmPlanText={'CONTRATAR'}
                      showHistory={previousCoverageCalcList?.length}
                      showCoveragesAndExtensions={true}
                      onConfirmPlan={async (index) => {
                        try {
                          if (!validateCoverageSelection(index)) {
                            return;
                          }

                          const questionnaireData = handleSaveQuestionnaireAnswer(null, true);
                          await useSaveQuestionnaireAnswerSyncRequest(questionnaireData);
                          await useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operation?.idDomainStatus }).then(() => { });
                          await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, coverageOption: index, idProductPlanSelected: idProductPlan } });
                          await useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: false });
                          await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });

                          const hasInternalProcessNumberAnswer = questionnaire.find(qst => qst.idQuestion === 3476)?.answer;
                          if (!hasInternalProcessNumberAnswer) {
                            await useRequestSompoGetInternalProcessNumberRequest({ idOperation: operation?.idOperation })
                              .then(async (response) => {
                                if (response.status !== 200) {
                                  return mc.error('Ocorreu um erro na requisição do sistema externo');
                                }
                              }).catch((e) => {
                                return mc.error('Ocorreu um erro na requisição do sistema externo');
                              })
                          }

                          await useGenerateQuoteRequest({
                            selectedClausesAdHock: selectedClauses,
                            idDomainStatus: 20,
                            idProductPlanSelected: idProductPlan,
                            preferredOption: index
                          })

                          history.push({ pathname: `/payment-configuration/${props.match?.params?.idOperation}`, state: { option: index, idProductPlanSelected: idProductPlan } });
                        } catch (e) {
                          loading.stop();
                          return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                        }
                      }}
                      onRecalculate={onRecalculate}
                      handleCheckCoverage={(value, index, idCoverage) => {
                        const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);
                        if (hasParameter) {
                          if (hasParameter.coveragesDisabled) {
                            hasParameter.coveragesDisabled = hasParameter.coveragesDisabled.filter((idCov) => idCov.idCoverage != idCoverage);
                            hasParameter.coveragesDisabled.push({ idCoverage, value });
                          } else if (value != null) {
                            hasParameter.coveragesDisabled = [{ idCoverage, value }];
                          }
                        } else {
                          recalculateParameters.current.push({ coverageCalcIndex: index, coveragesDisabled: [{ idCoverage, value }], idProductPlan })
                        }

                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      onRecalculateItem={onRecalculateItem}
                      openHistoryModel={(index) => {
                        setSelectedOption(index)
                      }}
                      onSelectDeductible={(value) => handleSelectDeductible(value)}
                      onOptionsDeductible={groupDeductible}
                      hasCoverageCalc={hasCoverageCalc}
                      minComission={minCommissionValue}
                      maxComission={maxComissionValue}
                      isInAnalysis={isInAnalysis}
                    />}
                </CoverageContainer>

                <div style={{ marginLeft: 15, marginRight: 15 }}>
                  <FormSection
                    sectionName="PLANS"
                    questionnaire={questionnaire}
                    setQuestionnaire={setQuestionnaire}
                    values={values}
                    errors={errors}
                    setFieldValue={setFieldValue}
                    setFieldError={setFieldError}
                    disableAll={isBound || finishedAnalysis}
                    ignoreModality
                    idProduct={props.match.params.idProduct}
                    idOperation={props.match.params.idOperation}
                    permissions={permissions}
                    onBlur={async (
                      question,
                      value,
                      setFieldValue,
                      questionnaireUpdated
                    ) => {
                      let questionnaireUpdatedAux = cloneDeep(questionnaireUpdated)
                      questionnaireUpdatedAux = questionnaireUpdatedAux.map(qst => {
                        if (question.idQuestion === 3521 && qst.idQuestion === question.idQuestion) {
                          qst.answer = value;
                        }

                        if (question.idQuestion === 3522 && qst.idQuestion === question.idQuestion) {
                          qst.answer = value;
                        }
                        return qst;
                      })

                      setQuestionnaire(questionnaireUpdatedAux);

                      if (question.idQuestion === 3521) {
                        // changeEndorsmentPremium.current = false;
                        handleCalculateCancellation(questionnaireUpdatedAux, coverageCalcList);
                      }

                      if (question.idQuestion === 3522) {
                        //   changeEndorsmentPremium.current = true;
                        handleCalculateCancellation(questionnaireUpdatedAux, coverageCalcList);

                        //   if (operation?.idDomain === 398) {
                        //     const idx = questionMappingAdhocParameters.current.findIndex(item => item.mapName === 'ENDORSEMENT_PREMIUM');
                        //     if (idx !== -1) {
                        //       questionMappingAdhocParameters.current[idx].mapValue = value;
                        //     } else {
                        //       questionMappingAdhocParameters.current.push({ mapName: 'ENDORSEMENT_PREMIUM', mapValue: value });
                        //     }
                        //   }

                        await useRecalculateSyncRequest(
                          {
                            recalculateParameters: recalculateParameters.current,
                            questionMappingAdhoc: questionMappingAdhocParameters.current,
                            idProductPlanSelected: idProductPlan
                          },
                          { draft: false }
                        );
                      }
                    }}
                    extraButtonsQuestion={(question) => {
                      if (question.idQuestion !== 3521) return null;
                      if (operation.idDomain !== 400 && operation.idDomain !== 398) return null;

                      return (
                        <RefreshButon type="button" onClick={() => handleCalculateCancellation(questionnaire, coverageCalcList, true)}>
                          <Icon name='generate' title='Consultar Parcelas' />
                        </RefreshButon>
                      )
                    }}
                    onQuestionChange={async (
                      question,
                      value,
                      setFieldValue,
                      questionnaireUpdated
                    ) => {
                      let questionnaireUpdatedAux = cloneDeep(questionnaireUpdated)
                      questionnaireUpdatedAux = questionnaireUpdatedAux.map(qst => {
                        if (question.idQuestion === 3533 && qst.idQuestion === question.idQuestion) {
                          qst.answer = value?.dsAnswerOption;
                          qst.idAnswerOption = value?.idAnswerOption;
                        } else if (question.idQuestion === 3495 && qst.idQuestion === question.idQuestion) {
                          qst.answer = value;
                        }
                        return qst;
                      })

                      if ([3533].includes(question.idQuestion)) {
                        handleCalculateCancellation(questionnaireUpdatedAux, coverageCalcList)
                      }
                    }}
                  />

                  <FormSection
                    sectionName="PLANS_PAYMENT"
                    questionnaire={questionnaire}
                    setQuestionnaire={setQuestionnaire}
                    values={values}
                    errors={errors}
                    setFieldValue={setFieldValue}
                    setFieldError={setFieldError}
                    disableAll={isBound}
                    ignoreModality
                    idProduct={props.match.params.idProduct}
                    idOperation={props.match.params.idOperation}
                    permissions={permissions}
                    onQuestionChange={(
                      question,
                      value,
                      setFieldValue,
                      questionnaireUpdated
                    ) => {

                    }}
                  />
                </div>

                <div style={{
                  marginTop: 25
                }}>
                  {coverageCalcList.map((calc, index) => {
                    if (calc?.idProductPlan && !index) {
                      return (
                        <Clauses
                          idOperation={calc.idOperation}
                          idProduct={calc.idProduct || operation?.idProduct}
                          idProductPlan={calc.idProductPlan}
                          isInAnalysis={isInAnalysis}
                          permission={handlePermissionEdit()}
                          isLoading={(isLoading) => setClausesLoading(isLoading)}
                          onSelectClauses={(onSelectClauses) => {
                            setSelectedClauses(onSelectClauses)
                          }}
                          reloadClauses={reloadClauses}
                          overwriteQstValues={overwriteQstValues}
                          clauseVersionNumber={questionnaire.find(qst => [3501].includes(qst.idQuestion) && qst?.answer)?.answer}
                        />
                      )
                    }
                    return <></>;
                  })}
                </div>

                <HasPermission permission={HAS_APPROVAL_AND_REJECT_PERMISSION && isInAnalysis}>
                  <div style={{ marginLeft: 15, marginRight: 15 }}>
                    <FormSection
                      sectionName="QUOTE_LETTER"
                      questionnaire={questionnaire}
                      setQuestionnaire={setQuestionnaire}
                      values={values}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      setFieldError={setFieldError}
                      disableAll={isBound}
                      ignoreModality={true}
                      idProduct={props.match.params.idProduct}
                      permissions={permissions}
                      onQuestionChange={(
                        question,
                        value,
                        setFieldValue,
                        questionnaireUpdated
                      ) => {
                        if (question?.idQuestion !== 3457 && !value?.idAnswerOption) return;

                        let idDomainStatus = value?.idAnswerOption === 8996 ? 19 : 16;

                        setOperation({
                          ...operation, document: {
                            ...operation.document,
                            idDomainStatus
                          }
                        });
                      }}
                    />
                  </div>
                </HasPermission>

                <Row>
                  <Col>
                  </Col>
                </Row>

                <ButtonContainer style={{ padding: '0 10px' }}>
                  <Button forth style={{ width: 'auto' }} onClick={() => handleBack()}> &lt; VOLTAR </Button>
                  <ButtonContent>
                    <HasPermission permission={!isBound}>
                      {(operation?.idOperation) &&
                        <HasPermission permission={HAS_CANCEL_PERMISSION}>
                          <LostCancelButton idQuestion={697} idOperation={props.match?.params?.idOperation} title={'PERDIDO'} />
                        </HasPermission>}

                      <HasPermission
                        permission={
                          isInAnalysis &&
                          operation?.idOperation &&
                          [8, 10, 443, 444, 445].includes(operation?.idDomainStatus) &&
                          HAS_APPROVAL_AND_REJECT_PERMISSION
                        }
                      >
                        <Button
                          type="button"
                          onClick={() => setNotesModal(true)}
                          third
                        >
                          MAIS INFO
                        </Button>
                      </HasPermission>

                      <HasPermission
                        permission={
                          isInAnalysis &&
                          operation?.idOperation &&
                          [8, 10, 116, 126, 141, 151, 178, 384, 443, 444, 445].includes(operation?.idDomainStatus) &&
                          HAS_APPROVAL_AND_REJECT_PERMISSION
                        }
                      >
                        <Button
                          id="btnContinue"
                          type="button"
                          onClick={() => {
                            validationSchema.current.validate(values)
                              .then(async () => {
                                try {
                                  await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, idProductPlanSelected: idProductPlan } });
                                  await useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: false });
                                  await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });
                                  goToNextPage.current = false;
                                  handleSaveQuestionnaireAnswer(props.match?.params?.idOperation)
                                } catch (e) {
                                  console.log("error", e);
                                  loading.stop();
                                  return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                                }
                              })
                              .catch((e) => {
                                console.log('validation error', e)
                              })
                          }}
                          style={{ marginLeft: 15 }}
                          custom={[Colors.WHITE, Colors.TERTIARY]}
                        >
                          SALVAR
                        </Button>
                      </HasPermission>
                      <HasPermission permission={!isInAnalysis && operation?.idDomain != null && ((operation?.idDomain === 26 && permissions.GENERATE_MRC) || (operation?.idDomain !== 26))}>
                        <Button
                          id="btnContinue"
                          type="button"
                          onClick={() => {
                            validationSchema.current.validate(values)
                              .then(async (index) => {
                                try {
                                  if (!validateCoverageSelection()) {
                                    return;
                                  }

                                  const questionnaireData = handleSaveQuestionnaireAnswer(null, true);
                                  await useSaveQuestionnaireAnswerSyncRequest(questionnaireData);
                                  await useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operation?.idDomainStatus }).then(() => { });
                                  await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, idProductPlanSelected: idProductPlan } });
                                  if (fullCoverageList?.coverageCalcList?.length && fullCoverageList?.coverageCalcList[0]?.coverageCalc) {
                                    for (const coverageCalc of fullCoverageList.coverageCalcList) {
                                      await useRecalculateSyncRequest(
                                        {
                                          recalculateParameters: recalculateParameters.current,
                                          idProductPlanSelected: coverageCalc.idProductPlan
                                        },
                                        { draft: false }
                                      );
                                    }
                                  } else {
                                    await useRecalculateSyncRequest(
                                      {
                                        recalculateParameters: recalculateParameters.current,
                                        idProductPlanSelected: idProductPlan
                                      },
                                      { draft: false }
                                    );
                                  }
                                  await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });

                                  const hasInternalProcessNumberAnswer = questionnaire.find(qst => qst.idQuestion === 3476)?.answer;
                                  if (!hasInternalProcessNumberAnswer) {
                                    await useRequestSompoGetInternalProcessNumberRequest({ idOperation: operation?.idOperation })
                                      .then(async (response) => {
                                        if (response.status !== 200) {
                                          return mc.error('Ocorreu um erro na requisição do sistema externo');
                                        }
                                      }).catch((e) => {
                                        return mc.error('Ocorreu um erro na requisição do sistema externo');
                                      })
                                  }
                                  await useGenerateQuoteRequest({ selectedClausesAdHock: selectedClauses, idDomainStatus: 16, idProductPlanSelected: idProductPlan })
                                  return history.push(`/quote/document/${operation?.idProduct}/${props?.match?.params?.idOperation}`);
                                } catch (e) {
                                  loading.stop();
                                  return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                                }
                              })
                              .catch((e) => {
                                console.log('validation error', e)
                              })
                          }}
                          style={{ marginLeft: 15 }}
                          custom={[Colors.WHITE, Colors.TERTIARY]}
                        >
                          {
                            operation?.idDomain == 254 || operation?.idDomain == 398 || operation?.idDomain == 400 ? `GERAR ENDOSSO` : "GERAR COTAÇÃO"
                          }
                        </Button>
                      </HasPermission>

                      <HasPermission permission={(isInAnalysis && HAS_APPROVAL_AND_REJECT_PERMISSION) && ((operation?.idDomain === 26 && permissions.GENERATE_MRC) || (operation?.idDomain !== 26))}>
                        <Button
                          id="btnContinue"
                          type="button"
                          onClick={() => {
                            buildValidation().validate(values, { abortEarly: false })
                              .then(async () => {
                                try {
                                  if (!validateCoverageSelection()) {
                                    return;
                                  }

                                  await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, idProductPlanSelected: idProductPlan } });
                                  await useRecalculateSyncRequest({
                                    recalculateParameters: recalculateParameters.current,
                                    idProductPlanSelected: idProductPlan
                                  }, { draft: false });
                                  await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });
                                  goToNextPage.current = true;
                                  await handleGenerateQuote(values)
                                } catch (e) {
                                  console.log("error", e);
                                  loading.stop();
                                  return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                                }
                              })
                              .catch((e) => {
                                onValidationError(e, mc, formikRef, questionnaire, [])
                              })
                          }}
                          style={{ marginLeft: 15 }}
                          custom={[Colors.WHITE, Colors.TERTIARY]}
                        >
                          {
                            operation?.idDomain == 254 || operation?.idDomain == 398 || operation?.idDomain == 400 ? `GERAR ENDOSSO` : "GERAR COTAÇÃO"
                          }
                        </Button>
                      </HasPermission>
                    </HasPermission>
                  </ButtonContent>
                </ButtonContainer>
              </Form>
            )
          }}
        </Formik>
      </Content>
    </Layout >
  )
}